import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  saveTurnoverGrouping,
  deleteCustomGrouping,
  turnoverGroupings,
} from "../../../store/actions";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import GroupList from "./groupList_copy";
import { isEqual, startCase } from "lodash";
import searchIcon from "../../../assets/images/searchIcon.png";
import OutsideClickHandler from "react-outside-click-handler";
import {
  DragDropContext,
  Draggable,
  Droppable,
} from "react-beautiful-dnd";
export const GroupingModal = (props) => {
  const { CustomGroupings, advanceGroupingValues, cloneGroup, refreshAgGrid } =
    props;
  const [groupingColumns, setGroupingColumns] = useState([]);
  const [customGroupings, setCustomGroupings] = useState([]);
  const [selectedColumn, setSelectedColumn] = useState("");
  const [groupingName, setGroupingName] = useState("");
  const [searchInput, showSearch] = useState(0);
  const [showColumns, setShowColumns] = useState(false);
  const [showGroupInput, setShowGroupInput] = useState(false);
  const [selectedGrouping, setSelectedGrouping] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [groupSearchText, setGroupSearchText] = useState("");
  const [groupingValues, setGroupingValues] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [draggedIndex, setDraggedIndex] = useState(-1);
  const [typeIdx, setTypeIdx] = useState(0);
  const [showHideSearch1, setShowHideSearch1] = useState(false);
  const [showHideSearch2, setShowHideSearch2] = useState(false);

  useEffect(() => {
    let groupingColumns = Object.keys(advanceGroupingValues).map((cl) => ({
      label: startCase(cl),
      value: cl,
    }));
    setGroupingColumns(groupingColumns);
    setCustomGroupings(CustomGroupings || []);
    if (CustomGroupings.length) {
      let firstIndex = CustomGroupings.map((e, i) => {
        return e.groupName;
      });
      setTypeIdx(firstIndex[0] && typeIdx);
      let grouping = CustomGroupings.find((g) => g.groupName === firstIndex[0]);
      if (!grouping) return;
      setSelectedGrouping(grouping);
      let values = advanceGroupingValues[grouping.columnName];
      let { groups } = grouping;
      let availableValues = values.filter((val) => {
        return !groups.find((grp) => grp.values && grp.values.includes(val));
      });
      setGroupingValues(availableValues);
    }
  }, []);

  function cancelSelectColumn() {
    setSelectedColumn("");
    setGroupingName("");
    setShowColumns(false);
  }

  function createNewGrouping() {
    let grouping = {
      columnName: selectedColumn,
      groupName: groupingName,
      company: props.UserReducer.companyId,
      groups: [],
    };
    setCustomGroupings([...customGroupings, grouping]);
    setGroupingValues([]);
    setShowColumns(false);
    setSelectedColumn("");
    setGroupingName("");
    setSelectedGrouping([...customGroupings, grouping][customGroupings.length]);
    setTypeIdx([...customGroupings, grouping].length - 1);

    let values = advanceGroupingValues[grouping.columnName];
    let { groups } = grouping;
    let availableValues = values.filter((val) => {
      return !groups.find((grp) => grp.values && grp.values.includes(val));
    });
    setGroupingValues(availableValues);
  }

  function findSelectedGrouping(groupName, idx) {
    let grouping = customGroupings.find((g) => g.groupName === groupName);
    if (!grouping) return;
    setSelectedGrouping(grouping);
    let values = advanceGroupingValues[grouping.columnName];
    let { groups } = grouping;
    let availableValues = values.filter((val) => {
      return !groups.find((grp) => grp.values && grp.values.includes(val));
    });
    setGroupingValues(availableValues);
    setTypeIdx(idx);
  }

  function cancelCreateGroup() {
    setShowGroupInput(false);
    setGroupName("");
  }

  function createGroup() {
    let group = {
      name: groupName,
      values: [],
    };
    selectedGrouping.groups.push(group);
    setGroupName("");
    setShowGroupInput(false);
    setSelectedGrouping({ ...selectedGrouping });
  }

  function deleteGroup(idx) {
    let deletedGroup = selectedGrouping.groups.splice(idx, 1).shift();
    setGroupingValues([...groupingValues, ...deletedGroup.values]);
    setSelectedGrouping({ ...selectedGrouping });
  }

  function removeValueFromGroup(grpIdx, valueIdx) {
    let value = selectedGrouping.groups[grpIdx].values
      .splice(valueIdx, 1)
      .shift();
    setGroupingValues([...groupingValues, value]);
    setSelectedGrouping({ ...selectedGrouping });
  }

  function handleDragStart(e, i) {
    e.dataTransfer.effectAllowed = "move";
    setDraggedIndex(i);
  }

  function handleDrop(dragIdx, dropIdx) {
    let toDrop = groupingValues.splice(dragIdx, 1).shift();
    let { groups } = selectedGrouping;
    groups[dropIdx].values.push(toDrop);
    setDraggedIndex(-1);
  }

  function handleDragOver(ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }

  async function deleteGrouping(_id, idx) {
    let deleted = await props.confirmDeleteGroupingProp(_id);
    if (deleted) {
      await props.turnoverGroupings(props.UserReducer.companyId);
      setCustomGroupings([...props.TURNOVER_GROUPINGS]);
      if (_id === selectedGrouping?._id) {
        setSelectedGrouping(null);
        setGroupingValues([]);
      }
      removeGrouping(idx);
    }
  }

  function removeGrouping(idx) {
    let deleted = customGroupings.splice(idx, 1);
    setCustomGroupings(customGroupings);
    if (deleted.groupName === selectedGrouping.groupName) {
      setSelectedGrouping(null);
    }
    let ChkLength = [customGroupings[customGroupings.length - 1]];
    let grouping = CustomGroupings.find(
      (g) => g.groupName === ChkLength[0].groupName
    );
    let idxx = customGroupings.length - 1;
    let groupName = grouping.groupName;
    findSelectedGrouping(groupName, idxx);
  }

  async function saveGroupings() {
    let groupings = customGroupings;
    let OrigGroups = cloneGroup;
    let checkGroupExitOrNot = groupings.filter((e) => {
      return e.groups.length === 0;
    });

    let cgGrouping = groupings
      .map((grp) => grp.groups)
      .flatMap((element) => element)
      .flat(2);
    let chkGroupsCgGropingValue = cgGrouping.map((e) => e.values);
    let chkGroupsCgGropingFlatValue = cgGrouping.flatMap((e) => e.values);
    let cloneGrouping = cloneGroup
      .map((grp) => grp.groups)
      .flatMap((element) => element)
      .flat(2);
    let chkGroupsCloneValue = cloneGrouping.map((e) => e.values);
    let chkGroupsCloneFlatValue = cloneGrouping.flatMap((e) => e.values);
    let ChkGroupsValue =
      JSON.stringify(chkGroupsCloneFlatValue) ===
      JSON.stringify(chkGroupsCgGropingFlatValue);
    let ChkGroups =
      JSON.stringify(chkGroupsCgGropingValue) ===
      JSON.stringify(chkGroupsCloneValue);

    if (
      !checkGroupExitOrNot.length ||
      ChkGroupsValue === false ||
      ChkGroups === false
    ) {
      let toSave = groupings.filter((grp) => {
        let orig = OrigGroups.find((gr) => gr.groupName === grp.groupName);
        return !isEqual(grp, orig);
      });

      await Promise.allSettled(
        toSave.map(async (grp) => {
          return props.saveTurnoverGrouping(grp);
        })
      );
      refreshAgGrid(true);
    }
  }

  const showSearchInput = (checkSearch) => {
    if (checkSearch === "selectedGroupingValues") {
      let showHide = !showHideSearch1;
      setShowHideSearch1(showHide);
      setSearchText("")
    }
    if (checkSearch === "selectedGrouping") {
      let showHide = !showHideSearch2;
      setShowHideSearch2(showHide);
      setGroupSearchText("")
    }
  };


  const onDragEnd = (result) => {
    if (
      result.destination == null ||
      result.destination.droppableId === "available"
    ) {
      console.log(result);
      return;
    }
    let toDrop = groupingValues.splice(result.source.index, 1).shift();
    let { groups } = selectedGrouping;
    let index = groups.findIndex(
      (x) => x.name === result.destination.droppableId
    );
    groups[index].values.push(toDrop);
    setDraggedIndex(index);
  };
  return (
    <Modal
      show={props.show}
      onHide={props.onClose}
      centered
      size="lg"
      className="grouping-model"
      dialogClassName="modal-1015w"
    >
      <Modal.Header>
        <Modal.Title>Advanced grouping</Modal.Title>
        <button className="btn close-btn" onClick={props.onClose}>
          x
        </button>
      </Modal.Header>
      <Modal.Body>
        <Tab.Container
          id="turnover-rate"
          defaultActiveKey={typeIdx}
          activeKey={typeIdx}
        >
          <Row>
            <Col sm={3}>
              <div className="type-label d-flex align-content-center justify-content-between">
                <OutsideClickHandler
                  onOutsideClick={() => {
                    setShowColumns(false);
                  }}
                >
                  <span onClick={() => setShowColumns(true)}>
                    Create New Grouping
                  </span>

                  {showColumns && (
                    <div className="group-text-field">
                      <label>Grouping name</label>
                      <input
                        autoFocus
                        type="text"
                        onChange={(e) => setGroupingName(e.target.value)}
                      />
                      <div className="type-list">
                        <label>Select Column</label>
                        <div className="type-list-fields">
                          <ul>
                            {groupingColumns.map((el, i) => {
                              return (
                                <div key={i}>
                                  <li>
                                    <input
                                      type="radio"
                                      name="group-type"
                                      value={el.value}
                                      checked={selectedColumn === el.value}
                                      onChange={(e) =>
                                        setSelectedColumn(e.target.value)
                                      }
                                    />
                                    <label htmlFor="test3">{el.label} </label>
                                  </li>
                                </div>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          className="btn close-btn"
                          onClick={cancelSelectColumn}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn save-btn"
                          onClick={createNewGrouping}
                          disabled={!groupingName || !selectedColumn}
                        >
                          Create
                        </button>
                      </div>
                    </div>
                  )}
                </OutsideClickHandler>
              </div>
              <Nav variant="pills" className="flex-column">
                {customGroupings.map((item, idx) => (
                  <Nav.Item
                    key={idx}
                    onClick={() => findSelectedGrouping(item.groupName, idx)}
                  >
                    <Nav.Link eventKey={idx}>
                      <strong>{item.groupName}</strong>
                      <p>{startCase(item.columnName)}</p>
                      <div
                        className="groups-delete-action"
                        onClick={async () =>
                          item._id
                            ? await deleteGrouping(item._id, idx)
                            : removeGrouping(idx)
                        }
                      ></div>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>
                <Tab.Pane eventKey={typeIdx}>
                  <div className="column-box-outer d-flex align-content-center justify-content-between">
                    <DragDropContext onDragEnd={onDragEnd}>
                      <div className="column-box">
                        <OutsideClickHandler
                          onOutsideClick={() => {
                            setShowHideSearch1(false);
                            setSearchText("")
                          }}
                        >
                          <h3 className="column-head d-flex align-items-center position-relative">
                            {selectedGrouping &&
                              startCase(selectedGrouping.columnName) + " Values"}
                            <button
                              className="btnSearch ms-auto border-0"
                              type="button"
                              onClick={() => {
                                let checkSearch = "selectedGroupingValues";
                                showSearchInput(checkSearch);
                              }}
                            >
                              <img src={searchIcon} alt="" />
                            </button>
                            {showHideSearch1 && (
                              <input
                                autoFocus
                                className="filterSearch"
                                type="text"
                                name="searchText"
                                value={searchText}
                                onChange={(e) =>
                                  setSearchText(
                                    e.target.value.replace(/[^a-z0-9]/gi, "")
                                  )
                                }
                              />
                            )}
                          </h3>
                        </OutsideClickHandler>
                        <div className="columns-list">
                          <ul className="in-drag">
                            <Droppable droppableId="available">
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  className="h-screen"
                                >
                                  {groupingValues
                                    .filter((col) => {
                                      return col.match(
                                        new RegExp(searchText, "i")
                                      );
                                    })
                                    .map((col, indx) => {
                                      return (
                                        <li
                                          key={indx}
                                          className="position-relative"
                                        >
                                          <Draggable
                                            key={col}
                                            draggableId={col}
                                            index={indx}
                                          >
                                            {(provided, snapshot) => (
                                              <div>
                                                <div
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps}
                                                  {...provided.dragHandleProps}
                                                  className={
                                                    snapshot.isDragging
                                                      ? "dragging-list"
                                                      : ""
                                                  }
                                                >
                                                  <span className="number-count">
                                                    {indx + 1}
                                                  </span>
                                                  <div className="inner-column-text">
                                                    {col}
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </Draggable>
                                        </li>
                                      );
                                    })}
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </ul>
                        </div>
                      </div>
                      <div className="column-box">
                        <OutsideClickHandler
                          onOutsideClick={() => {
                            setShowHideSearch2(false);
                            setGroupSearchText("")
                          }}
                        >
                          <h3 className="column-head d-flex align-items-center position-relative">
                            {selectedGrouping &&
                              selectedGrouping.groups.length + " Groups"}
                            <button
                              className="btnSearch ms-auto border-0"
                              type="button"
                              onClick={() => {
                                let checkSearch = "selectedGrouping";
                                showSearchInput(checkSearch);
                              }}
                            >
                              <img src={searchIcon} alt="" />
                            </button>
                            {showHideSearch2 && (
                              <input
                                autoFocus
                                className="filterSearch"
                                type="text"
                                name="groupSearchText"
                                value={groupSearchText}
                                onChange={(e) =>
                                  setGroupSearchText(
                                    e.target.value.replace(/[^a-z0-9]/gi, "")
                                  )
                                }
                              />
                            )}
                          </h3>
                        </OutsideClickHandler>

                        <div className="columns-list">
                          <div className="create-group-box">
                            {selectedGrouping && (
                              <div className="group-create-field">
                                <OutsideClickHandler
                                  onOutsideClick={() => {
                                    setShowGroupInput(false);
                                  }}
                                >
                                  <button
                                    className="btn text-btn"
                                    onClick={() => setShowGroupInput(true)}
                                  >
                                    Create group
                                  </button>
                                  {showGroupInput && (
                                    <div className="group-text-field position-static shadow-none border mb-3">
                                      <label>Group name</label>
                                      <input
                                        autoFocus
                                        type="text"
                                        onChange={(e) =>
                                          setGroupName(e.target.value)
                                        }
                                      />
                                      <div className="modal-footer">
                                        <button
                                          className="btn close-btn"
                                          onClick={cancelCreateGroup}
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          className="btn save-btn"
                                          onClick={createGroup}
                                        >
                                          Create Group
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </OutsideClickHandler>
                              </div>
                            )}
                          </div>
                          <div className="all-group-area">
                            {selectedGrouping?.groups?.length ? (
                              <GroupList
                                groups={selectedGrouping.groups}
                                groupFilter={groupSearchText}
                                deleteGroup={deleteGroup}
                                deleteGroupValue={removeValueFromGroup}
                                handleDrop={handleDrop}
                                handleDragOver={handleDragOver}
                                draggedOver={draggedIndex}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </DragDropContext>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn close-btn" onClick={props.onClose}>
          Cancel
        </button>
        <button
          className="btn save-btn"
          onClick={async () => {
            await saveGroupings();
            await props.turnoverGroupings(props.UserReducer.companyId);
            props.onClose();
            props.refreshGrid();
          }}
        >
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = ({ UserReducer, TurnoverReducer }) => {
  const {
    TURNOVER_RATE,
    TURNOVER_VIEWS,
    TURNOVER_GROUPINGS,
    GROUPING_ALLOW_DELETE,
  } = TurnoverReducer;
  return {
    UserReducer,
    TURNOVER_RATE,
    TURNOVER_VIEWS,
    TURNOVER_GROUPINGS,
    GROUPING_ALLOW_DELETE,
  };
};
export default connect(mapStateToProps, {
  saveTurnoverGrouping,
  deleteCustomGrouping,
  turnoverGroupings,
})(GroupingModal);
